import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {ENVIRONMENT_INITIALIZER, EnvironmentProviders, inject, Provider} from '@angular/core';
import {AppraiserPlatformService} from "./services/platform";
import {AppraiserUtilsService} from "./services/utils";
import {appraiserLoadingInterceptor} from "./services/loading/loading.interceptor";
import {AppraiserLoadingService} from "./services/loading/loading.service";


export type AppraiserProviderConfig = {
  mockApi?: {
    delay?: number;
    services?: any[];
  },
}

/**
 * appraiser provider
 */
export const provideAppraiser = (): Array<Provider | EnvironmentProviders> => {
  // Base providers
  // Return the providers
  return [
    provideHttpClient(withInterceptors([appraiserLoadingInterceptor])),
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(AppraiserLoadingService),
      multi: true,
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(AppraiserPlatformService),
      multi: true,
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(AppraiserUtilsService),
      multi: true,
    },
  ];
};

